export enum KeyTypeEnum {
  Back = 'back',
  Stop = 'stop',
  FastForward = 'fastForward',
  Rewind = 'rewind',
  Pause = 'pause',
  Left = 'left',
  Right = 'right',
  Up = 'up',
  Down = 'down',
  Enter = 'enter',
  PlayPause = 'playPause',
  Play = 'play',
}
export type KeyTypeValue = `${KeyTypeEnum}`
const TIZEN_BACK_KEY = 'XF86Back'
const XUMO_BACK_KEY = 'Escape'
const TIZEN_FFW_KEY = 'XF86AudioNext'
const TIZEN_RW_KEY = 'XF86AudioRewind'
const TIZEN_PAUSE_KEY = 'XF86AudioPause'
const TIZEN_PLAY_KEY = 'XF86AudioPlay'
const TIZEN_STOP_KEY = 'XF86AudioStop'

export const KEY_MAP = {
  back: {
    keys: ['Backspace', 'Back', TIZEN_BACK_KEY, XUMO_BACK_KEY],
    codes: [8, 166, 10009],
  },
  stop: {
    keys: ['Stop', TIZEN_STOP_KEY],
    codes: [413],
  },
  fastForward: {
    keys: ['FFW', TIZEN_FFW_KEY],
    codes: [417, 228],
  },
  rewind: {
    keys: ['RW', TIZEN_RW_KEY],
    codes: [412, 227],
  },
  pause: {
    keys: ['Pause', TIZEN_PAUSE_KEY],
    codes: [19, 179],
  },
  left: {
    keys: ['ArrowLeft', 'Left'],
    codes: [37],
  },
  right: {
    keys: ['ArrowRight', 'Right'],
    codes: [39],
  },
  play: {
    keys: ['Play', TIZEN_PLAY_KEY],
    codes: [415],
  },
  up: {
    keys: ['ArrowUp', 'Up'],
    codes: [38],
  },
  down: {
    keys: ['ArrowDown', 'Down'],
    codes: [40],
  },
  enter: {
    keys: ['Enter'],
    codes: [13],
  },
  playPause: {
    keys: [''],
    codes: [10252, 179],
  },
}

export type KeyHandler = {
  callback: (key?: KeyTypeValue) => void
  options?: {
    stopPropagation?: boolean
  }
}

export type Subscribers = {
  [key in KeyTypeValue]?: KeyHandler[]
}

export type KeyDownContextType = {
  subscribe: (key: KeyTypeValue, handler: KeyHandler) => () => void
}
